export default __webpack_public_path__ + "static/media/medicine-2.f81b636a.png";